import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { Icon } from '../../lib/icons.js';

export function Button({
  children,
  icon,
  variant = 'default',
  block,
  busy,
  className = '',
  ...rest
}: {
  children?: ReactNode;
  icon?: string | undefined;
  variant?: 'default' | 'primary' | 'alert' | 'ghost';
  block?: boolean;
  busy?: boolean | undefined;
  ref?: Ref<HTMLButtonElement>;
} & ButtonHTMLAttributes<HTMLButtonElement>): ReactNode {
  return (
    <button
      type="button"
      className={`btn ${variant !== 'default' ? `btn-${variant}` : ''} ${block ? 'btn-block' : ''} ${className}`}
      data-busy={busy ? 'true' : undefined}
      {...rest}
    >
      {busy ? <span className="spinner" aria-hidden="true" /> : icon ? <Icon name={icon} size={17} /> : null}
      {children}
    </button>
  );
}

export function IconButton({
  icon,
  label,
  size = 38,
  iconSize,
  className = '',
  ...rest
}: { icon: string; label: string; size?: number; iconSize?: number } & ButtonHTMLAttributes<HTMLButtonElement>): ReactNode {
  return (
    <button type="button" className={`icon-btn ${className}`} aria-label={label} title={label} style={{ width: size, height: size }} {...rest}>
      <Icon name={icon} size={iconSize ?? Math.round(size * 0.45)} />
    </button>
  );
}
